import Vue from '@/index.js'
import page from '@/mixins/page'

// Подключение стилей только для этой страницы
require('./page.scss')

const components = {
  razmOrder: () => import('../../components/layout/razm-order.vue'),
  razmOrder2: () => import('../../components/layout/razm-order2.vue')
}


export default new Vue({
  mixins: [page],
  el: '#app',
  data () {
    return {
      amount: 1,
      slideNum: 1,
      digit: true,
      price: []
    }
  },
  components,
  methods: {
    async addToCart ($event) {
      //  const variant = document.querySelector('input[name=variant]:checked').value
      const form = $event.target
      const action = form.action
      const formData = new FormData(form)
      const sidebarCart = window['__sidebar__'].cart
      const cartLabel = Number(sidebarCart.label)
      const amount = cartLabel + Number(form.amount.value)
      sidebarCart.label = `${amount}`

      await this.$axios.post(action, formData).then(response => {
        sidebarCart.items = JSON.parse(response.data)
      })

    },
    async addToFav (productId) {
      const variant = document.querySelector(`#product_${productId} input[name=variant]:checked`).value
      const sidebarFav = window['__sidebar__'].favorites
      const action = sidebarFav.action
      const form = {
        act: "add",
        variant: variant
      }

      let formData = new FormData()
      Object.keys(form).forEach(key => formData.append(key, form[key]));
     await this.$axios.post(action, formData).then(response => {
        sidebarFav.items = JSON.parse(response.data)
        sidebarFav.label = `${sidebarFav.items.length}`
      })
    },
    async fastOrder (productId) {
      const variant = document.querySelector(`#product_${productId} input[name=variant]:checked`).value
      const name = document.querySelector(`#product_${productId} .catalog-product__title a`).innerHTML
      const color = document.querySelector(`#product_${productId} input[name=variant]:checked`).dataset.color
      const colorName = document.querySelector(`#product_${productId} input[name=variant]:checked`).dataset.colorname
      this.$bus.$emit('fastOrder',{
        name: name,
        color: color,
        colorName: colorName,
        variant: variant
      })
    },
    getRazm(){
      this.$bus.$emit('razmOrder')
    },
    getRazm2(){
      this.$bus.$emit('razmOrder2')
    },
    changePrice (variantId, productId, price, compare_price) {
      // this.price[productId] = price
      //console.log('compare_price', compare_price)   
      document.querySelectorAll('[data-p="'+productId+'"]')[0].innerHTML = price
      if (compare_price == 0) {
        document.querySelectorAll('[data-p="'+productId+'"]')[1].innerHTML = ''
      } else if (compare_price) {
        document.querySelectorAll('[data-p="'+productId+'"]')[1].innerHTML = compare_price        
      } else {
        document.querySelectorAll('[data-p="'+productId+'"]')[1].innerHTML = ''        
      }
      
      // console.log(variantId)
      //  console.log(productId)
       // console.log(compare_price)      

      const form = {
        variant: variantId
      }

      let formData = new FormData()
      Object.keys(form).forEach(key => formData.append(key, form[key]));
      this.$axios.post('/ajax/get_color.php', formData).then(response => {
        // console.log(response)
        // console.log(response.data)
        // console.log(response.data.image)
        document.querySelectorAll('[data-product="'+productId+'"]')[0].src = response.data.image
      })

    }
  }
})
